import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    userData: null,
  },
  reducers: {
    getUserDetails: (state, action) => {
      state.userData = action.payload;
    },
    logoutUser: (state) => {
      state.userData = null; // Reset user data on logout
    },
  },
});

// Action creators are generated for each case reducer function
export const { getUserDetails, logoutUser } = userSlice.actions;

export default userSlice.reducer;
